export default "images/vertical risk field.png";